import { createSelector } from 'reselect';
import { getGameStaticData } from '@gameday/utils/selectors/getGameStaticData';
import { getLanguage } from '@gameday/utils/selectors/getLanguage';
import getQueryParamOverride from '@gameday/utils/getQueryParamOverride';

const UNDEF = 'undefined';

const getPartnerKey = (epglist, epgConfig) => {
    for (const [key, value] of Object.entries(epglist)) {
        if (epgConfig?.[key]) {
            return key;
        }
    };
};

const useContentEpgOverride = getQueryParamOverride('useContentEpg');

const getDeviceInteraction = (state) => state.config?.deviceInteraction || {};
// Stick with epgGameday for now, and switch out to epgGamedayById
// once we migrate to schedule + broadcast
const getEpgGameday = (state) => state.config?.epgGameday || {};
const getGameContext = (state) => state.config?.context?.gameContext;
const getUseContentEpg = (state) => (useContentEpgOverride ?? state.config?.useContentEpg);
const getMediaLinks = (state) => getUseContentEpg(state) ? state.contentMediaLinks : state.mediaLinks;
const getBlockLoginActivities = (state) => state?.config?.blockLoginActivities;
const getPartnerBroadcasterConfig = (state) => {
    let partnerKey;
    const useContentEpg = getUseContentEpg(state);
    const epgConfig = getEpgGameday(state);
    const { tv } = getMediaLinks(state);

    if (typeof epgConfig === UNDEF) {
        return;
    }

    const epglist = tv?.list?.[0] || {};

    if (useContentEpg) {
        partnerKey = getPartnerKey(epglist, epgConfig);
    }

    const mediadata = useContentEpg ? epglist?.[partnerKey] : epglist;
    const configdata = useContentEpg ? epgConfig?.[partnerKey] : epgConfig?.[epglist?.id];
    const useFgow = configdata?.useFgow;

    if (useFgow || (!useFgow && typeof mediadata !== UNDEF)) {
        return configdata;
    }
};

export const getMediaLinksState = createSelector(
    [getGameStaticData, getMediaLinks, getDeviceInteraction, getGameContext, getLanguage, getPartnerBroadcasterConfig, getBlockLoginActivities],
    (gameStaticData, mediaLinks, deviceInteraction, gameContext, language, partnerBroadcaster, blockLoginActivities) => {
        const {
            venue: {
                timeZone = {}
            },
            teams,
            datetime: {
                dateTime = ''
            },
            gamePk
        } = gameStaticData;

        const { tv, audio } = mediaLinks;

        return {
            audio,
            dateTime,
            deviceInteraction,
            gamePk,
            gameContext,
            language,
            teams,
            tv,
            tz: timeZone?.id ?? '',
            partnerBroadcaster,
            blockLoginActivities
        };
    }
);
